import styled from "styled-components"

export const Select = styled.select`
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: ${({ theme }) => theme.typography.body.fontFamily};
  font-size: ${({ theme }) => theme.typography.body.fontSize};
  border: 1px solid ${({ theme }) => theme.palette.primary.main};
  text-overflow: ellipsis;
  white-space: nowrap;
`
